import { Layout5050 } from "@/components/layout-50-50";
const CARD_INFO = {
  title: "We couldn't find what you were looking for",
  description: "There is an issue with the link you tried to visit.",
  intent: "danger",
  badge: "404: PAGE NOT FOUND"
} as const;
export default function NotFoundPage() {
  return <Layout5050 companyId={""} cardInfo={CARD_INFO} variant="unbranded" data-sentry-element="Layout5050" data-sentry-component="NotFoundPage" data-sentry-source-file="404.tsx" />;
}